import { render, staticRenderFns } from "./platform-dialog.vue?vue&type=template&id=4a4c7c82&scoped=true"
import script from "./platform-dialog.vue?vue&type=script&lang=js"
export * from "./platform-dialog.vue?vue&type=script&lang=js"
import style0 from "./platform-dialog.vue?vue&type=style&index=0&id=4a4c7c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4c7c82",
  null
  
)

export default component.exports